<div class="d-flex flex-column" [ngClass]="{'POPUP_LG': size.sizeWindow === SizeWindow.XS, 'POPUP_SM': size.sizeWindow === SizeWindow.SM }" [ngStyle]="{'max-width': maxWidth ? maxWidth+'px' : maxWidthPercent + '%', 'max-height': maxHeight ? maxHeight+'px' : maxHeightPercent + '%',
                                                                                                    'width': width ? width+'px' : widthPercent + '%', 'height': height ? height+'px' : heightPercent + '%', 'overflow': overflow }">
    <div> <!--ENTETE -->
        <div class="d-flex align-items-center mb-2">
            <img *ngIf="displaySocieteLogo"  class="imgHeaderPopup" src="{{ fileStoragePath }}{{ Document_Logo_URL }}" alt="logo">
            <img *ngIf="!displaySocieteLogo" class="imgHeaderPopup" src="../../../../assets/logo_EspaceNotaire.png">
            <div class="d-flex flex-column w-100 mb-2">
                <span class="titlePopup">
                    <b><ng-content select="[titre-popup]"></ng-content></b> <!-- CONTENU DYNAMIQUE ICII -->
                </span>
            </div>
        </div>
      
    </div>

    <div class="p-3">  <!--CORPS -->
      <ng-content select="[corps]"></ng-content>                  <!-- CONTENU DYNAMIQUE ICII -->
    </div>

    <div class="mt-auto d-flex justify-content-center gap-3">  <!--ACTIONS -->
      <ng-content select="[actions]"></ng-content>                <!-- CONTENU DYNAMIQUE ICII -->
    </div>
</div>



<!-- TEMPLATE À COPIER COLLER CI-DESSOUS -->


<!-- <app-template-popup [size]="" [height]="" [width]="" [displaySocieteLogo]="">
    <ng-container titre-popup>  LE TITRE DE LA POPUP</ng-container>

    <ng-container corps>  LE CONTENU HTML </ng-container>

    <ng-container actions>  UNIQUEMENT LES BOUTTONS. LE STYLE DE L'ALIGNEMENT S'APPLIQUE AUTOMATIQUEMENT</ng-container>

</app-template-popup> -->